import React from "react";

import useOutsideClick, { keyActivate } from "../useOutsideClick";

export const MI = {
  rename: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    </svg>
  ),
  duplicate: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </svg>
  ),
  up: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" />
    </svg>
  ),
  down: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" />
    </svg>
  ),
  power: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0" /><line x1="12" y1="2" x2="12" y2="12" />
    </svg>
  ),
  trash: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" />
    </svg>
  ),
  swap: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  ),
};

export default function KebabMenu({ items, onClose }) {
  useOutsideClick(true, onClose);
  return (
    <div className="gmba-menu" style={{ top: 40, right: 2 }} onClick={(e) => e.stopPropagation()}>
      {items.map((item, i) => {
        // Keyed off the item it follows, not Math.random(): a fresh key every
        // render remounted the divider on each pass and forfeited
        // reconciliation. Labels are unique within a menu, so this is stable.
        if (item === "divider") {
          const prev = items[i - 1];
          return <div key={`div-${prev && prev.label ? prev.label : "top"}`} className="gmba-mdiv" />;
        }
        if (item.disabled) {
          return (
            <div key={item.label} className="gmba-mi" style={{ opacity: 0.4, cursor: "default" }} aria-disabled="true">
              {item.icon}
              {item.label}
            </div>
          );
        }
        const activate = () => {
          onClose();
          item.onClick();
        };
        return (
          <div
            key={item.label}
            className={`gmba-mi${item.danger ? " gmba-danger" : ""}`}
            onClick={activate}
            {...keyActivate(activate)}
          >
            {item.icon}
            {item.label}
          </div>
        );
      })}
    </div>
  );
}
